module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-header"
  }, [_c('span', {
    staticClass: "game"
  }, [_vm._v(_vm._s(_vm._f("translate")('productName')) + " - ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("translate")('round')))]), _vm._v(" "), _c('span', {
    staticClass: "game-round"
  }, [_vm._v(_vm._s(_vm.gameStatus.displayRoundNumber))]), _vm._v(" "), (_vm.gameStatus.roundInProgress) ? _c('span', [_vm._v(_vm._s(_vm._f("translate")('in_progress')))]) : _vm._e(), _vm._v(" "), (_vm.gameStatus.countdown) ? _c('span', [_vm._v(_vm._s(_vm._f("translate")('starts_in')))]) : _vm._e(), _vm._v(" "), (_vm.gameStatus.countdown) ? _c('span', {
    staticClass: "game-countdown"
  }, [_vm._v(_vm._s(_vm.moment.utc(_vm.gameStatus.startingIn * 1000).format('m:ss')))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f085293e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/terminal/main/GameHeader.vue
// module id = 412
// module chunks = 0